import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useIsCanceledQuery = () => {
  const query = useQuery({
    queryKey: [QueryKeys.CANCELED],
    queryFn: accountRepo.getIsCanceled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};
